import { Ellipsis, X } from "lucide-react";
import { Link, useLocation } from "react-router-dom";
import MobileTable from "./MobileTable";
import Menu from "../menu/Menu";
import loadStatus from "../../util/loadStatus";
import Loading from "../loading/Loading";

const Table = ({ columns, data, link, button, loading }) => {
  const list = [
    { id: 1, text: "Delete", type: "link" },
    { id: 2, text: "Details", type: "button" },
  ];
  const location = useLocation();
  return (
    <>
      <table className="  text-text-1 hidden sm:table overflow-auto">
        <thead className="text-text-gen w-full sticky top-0 z-10">
          <tr>
            {columns.map((col, index) => {
              return (
                <th
                  className="py-3 px-2 uppercase  text-sm font-medium sticky bg-primary/70"
                  scope="col"
                  key={index}
                  id={col.id}
                >
                  {col.text}
                </th>
              );
            })}
          </tr>
        </thead>
        {loading === loadStatus.loading ? (
          <tr className="!border-none !bg-transparent">
            <td
              colSpan={columns.length}
              className="!border-none !border-transparent "
            >
              <div className="h-72 flex items-center justify-center mx-auto w-fit !border-none">
                <Loading />
              </div>
            </td>
          </tr>
        ) : (
          <tbody className="text-text-1/85">
            {data.map((item, index) => {
              return (
                <tr key={index}>
                  {columns.map((col, indexTwo) => {
                    // FInd Path
                    let path = `${location.pathname}/${item.id}`;
                    if (col.text === "Role") {
                      path = `/settings/permissions/${item.id}`;
                    } else if (location.pathname === "/project-requests") {
                      path = `/projects/${item.id}`;
                    }
                    //Find path end
                    if (col.id === "num") {
                      return (
                        <td key={indexTwo} className="table-data">
                          {++index}
                        </td>
                      );
                    } else if (col.id === "name" || col.id === "nice_name") {
                      return (
                        <td
                          key={indexTwo}
                          className={`table-data text-left ${
                            button ? " cursor-pointer hover:text-primary" : ""
                          }`}
                          onClick={(e) =>
                            button ? button(true, item.id) : () => {}
                          }
                        >
                          {link ? (
                            <Link className="hover:text-primary/70" to={path}>
                              {item[col.id].length >= 30
                                ? item[col.id].slice(0, 35) + "...."
                                : item[col.id]}
                              {/* {item[col.id]} */}
                            </Link>
                          ) : (
                            item[col.id]
                          )}
                        </td>
                      );
                    } else if (col.id === "action") {
                      return (
                        <td
                          key={indexTwo}
                          className="table-data text-right flex justify-center items-center gap-x-4"
                        >
                          <Menu
                            list={list}
                            firstIcon={<X size={20} className="menu-icon" />}
                            secondIcon={
                              <Ellipsis size={20} className="menu-icon" />
                            }
                          />
                        </td>
                      );
                    } else if (col.id === "color") {
                      return (
                        <td key={indexTwo} className="table-data text-left ">
                          <span
                            className={`px-8 py-1 rounded-md `}
                            style={{ backgroundColor: item[col.id] }}
                          ></span>
                        </td>
                      );
                    } else
                      return (
                        <td key={indexTwo} className="table-data ">
                          {item[col.id] || "N/A"}
                        </td>
                      );
                  })}
                </tr>
              );
            })}
          </tbody>
        )}
      </table>
      <MobileTable columns={columns} data={data} link={link} button={button} />
    </>
  );
};

export default Table;
